import { createApp } from 'vue'
import App from './App.vue'

import './css/bootstrap.min.css'

createApp(App).mount('#app')
